import React from "react";
// hook
import { useStyles } from "../hooks/table.useStyles";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";
// UI
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
// constants
import { TabKey } from "../MasterMaintenance.constants";
// method
import { setSortData } from "../methods/common.methods";

export const MasterMaintenanceDZUserRegistrationTbody = (props: any) => {
  const { pageInfo, selected, order, orderBy } = props;
  const classes = useStyles();
  const { t } = useLocale({
    defaultPath: "modules.components.MasterMaintenance.dZUserRegistration",
  });

  return (
    <TableBody>
      {setSortData(props.data, order, orderBy, TabKey.DZUserRegistration)
        .slice(
          pageInfo.page * pageInfo.rowsPerPage,
          pageInfo.page * pageInfo.rowsPerPage + pageInfo.rowsPerPage
        )
        .map((row: any, index: number) => {
          return (
            <TableRow className={classes.tbody} hover tabIndex={-1} key={index}>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EditIcon />}
                  onClick={() =>
                    props.handleEdit(row, TabKey.DZUserRegistration)
                  }
                >
                  {t("edit")}
                </Button>
              </TableCell>
              <TableCell className={classes.nowrap}>{row.given_name}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.family_name}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.middle_name}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.company_name}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.customer_no}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.customer_name}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.affiliate_cd}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.primary_locale.toLocaleUpperCase()}
              </TableCell>
              <TableCell className={classes.nowrap}>{row.tel_no}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.mail_address}
              </TableCell>
              <TableCell className={classes.nowrap}>{row.role_id}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.sms_receive_notification ? "Y" : "N"}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.mail_receive_notification ? "Y" : "N"}
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EditIcon />}
                  onClick={() =>
                    props.handleEdit(row, TabKey.DZUserRegistration)
                  }
                >
                  {t("edit")}
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  );
};
